// @flow
import { DURATION, EASING, TRANSITION_DEF } from '../constants';
import styled, { keyframes } from 'styled-components';

const revealScaling = keyframes`to { transform: scale3d(1, 1, 1); }`;

export const Overlay = styled.rect`
    fill: ${p => p.theme.white};
    opacity: 0.9;
`;

export const ScaleGroup = styled.g`
    animation: ${revealScaling} ${DURATION} ${EASING} forwards;
    transform: scale3d(0, 0, 1);
`;

export const PopupContainer = styled.circle`
    fill: transparent;
    transition: ${TRANSITION_DEF};
`;

export const CloseButton = styled.circle`
    fill: ${p => p.theme.white};
    stroke: ${p => p.theme.heavyGrey};
    stroke-width: 2px;
    transition: ${TRANSITION_DEF};
`;

export const CrossPath = styled.path`
    stroke: ${p => p.theme.heavyGrey};
    stroke-width: 2px;
`;

export const ClickableArea = styled.circle`
    cursor: pointer;
    opacity: 0;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/popup/style.js